import React, { useEffect, useState } from 'react';
import { Box, Grid, List, ListItem, Typography } from '@mui/material';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { GoogleMap, LoadScript } from '@react-google-maps/api';

export function NewDoohCampaign() {

   const mapStyles = {
      height: "400px",
      width: "100%"
   };

   const defaultCenter = {
      lat: 40.7128,
      lng: -74.0060
   };

   return (
      <div>
         <Box>
            <h2>New Dooh Campaign</h2>
         </Box>
         <Box>
            <Grid container spacing={2}>
               <Grid item xs={3}>
                  <Box>
                     <List>
                        <ListItem className='fs-2'>Basic Information</ListItem>
                        <ListItem className='fs-2'>Geo-Targets</ListItem>
                        <ListItem className='fs-2'>Venue Types</ListItem>
                        <ListItem className='fs-2'>Budget and Scheduling </ListItem>
                        <ListItem className='fs-2'>Ad Content </ListItem>

                     </List>
                  </Box>
               </Grid>
               <Grid item xs={9} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} >
                  <Box className="card omega-forms">
                     <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }}>
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                           <Typography level="title-sm" className='fs-1'>Basic Information</Typography>
                        </Box>
                        <Grid container spacing={2}>
                           <Grid item xs={4}>
                              <Typography level="title-sm" className='fs-2'>Campaign Name</Typography>
                              <Typography level="body-xs" className='fs-3' htmlFor="demand">Enter the name of the Campaign</Typography>
                           </Grid>
                           <Grid item xs={8}>
                              <InputText id="demand" placeholder="" className="mr-2" />
                           </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                           <Grid item xs={4}>
                              <Typography level="title-sm" className='fs-2'>Advertiser Name </Typography>
                              <Typography level="body-xs" className='fs-3'>Enter the name of the advertiser </Typography>
                           </Grid>
                           <Grid item xs={8}>
                              <InputText id="demand" placeholder="" className="mr-2" />
                           </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                           <Grid item xs={4}>
                              <Typography level="title-sm" className='fs-2'>Advertiser Domain  </Typography>
                              <Typography level="body-xs" className='fs-3'>Enter the domain of the  advertiser</Typography>
                           </Grid>
                           <Grid item xs={8}>
                              <InputText id="demand" placeholder="" className="mr-2" />
                           </Grid>
                        </Grid>
                     </Box>
                     <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-top form-group-border-bottom">
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                           <Typography level="title-sm" className='fs-1'>Geo-Targets</Typography>
                        </Box>
                        <Grid container spacing={2}>
                           <Grid item xs={4}>
                              <Typography level="title-sm" className='fs-2'>Country</Typography>
                              <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the  Country</Typography>
                           </Grid>
                           <Grid item xs={8}>
                              <Dropdown optionLabel="name" placeholder="" className="" />
                           </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                           <Grid item xs={4}>
                              <Typography level="title-sm" className='fs-2'>State</Typography>
                              <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the  State</Typography>
                           </Grid>
                           <Grid item xs={8}>
                              <Dropdown optionLabel="name" placeholder="" className="" />
                           </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                           <Grid item xs={4}>
                              <Typography level="title-sm" className='fs-2'>District/Country</Typography>
                              <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the  District/Country</Typography>
                           </Grid>
                           <Grid item xs={8}>
                              <Dropdown optionLabel="name" placeholder="" className="" />
                           </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                           <Grid item xs={4}>
                              <Typography level="title-sm" className='fs-2'>Postal Code</Typography>
                              <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the  Postal Code</Typography>
                           </Grid>
                           <Grid item xs={8}>
                              <Dropdown optionLabel="name" placeholder="" className="" />
                           </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                           <Grid item xs={4}>
                              <Typography level="title-sm" className='fs-2'>inclusion Geo-Fence</Typography>
                              <Typography level="body-xs" className='fs-3' htmlFor="demand"></Typography>
                           </Grid>
                           <Grid item xs={8}>
                              <LoadScript googleMapsApiKey="AIzaSyD5vFA_pK2Xegsa4cn2WRW-CKbXku2yY9g">
                                 <GoogleMap
                                    mapContainerStyle={mapStyles}
                                    zoom={12}
                                    center={defaultCenter}
                                 >
                                    {/* Child components, such as markers, can be added here */}
                                 </GoogleMap>
                              </LoadScript>
                           </Grid>
                        </Grid>
                     </Box>
                     <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-bottom">
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                           <Typography level="title-sm" className='fs-1'>Venue Types</Typography>
                        </Box>

                        <Grid container spacing={2}>
                           <Grid item xs={4}>
                              <Typography level="title-sm" className='fs-2'>Outdoor or Indoor Screens </Typography>
                              <Typography level="body-xs" className='fs-3' htmlFor="demand">Select indoor,outdoor or both type of screens  </Typography>
                           </Grid>
                           <Grid item xs={8}>
                              <Dropdown optionLabel="name" placeholder="" className="" />
                           </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                           <Grid item xs={4}>
                              <Typography level="title-sm" className='fs-2'>Venue Types</Typography>
                              <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the Venue types </Typography>
                           </Grid>
                           <Grid item xs={8}>
                              <Dropdown optionLabel="name" placeholder="" className="" />
                           </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                           <Grid item xs={4}>
                              <Typography level="title-sm" className='fs-2'>Supported Ad Formats</Typography>
                              <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the supported of formats required </Typography>
                           </Grid>
                           <Grid item xs={8}>
                              <Dropdown optionLabel="name" placeholder="" className="" />
                           </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                           <Grid item xs={4}>
                              <Typography level="title-sm" className='fs-2'>Screen Orientation *</Typography>
                              <Typography level="body-xs" className='fs-3' htmlFor="demand">Enter the Screen Orientation </Typography>
                           </Grid>
                           <Grid item xs={8}>
                              <InputText id="service-fee" placeholder="" className="mr-2" />
                           </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                           <Grid item xs={4}>
                              <Typography level="title-sm" className='fs-2'>Preferred Supply Source  </Typography>
                              <Typography level="body-xs" className='fs-3' htmlFor="demand">Select preferred supply source</Typography>
                           </Grid>
                           <Grid item xs={8}>
                              <Dropdown optionLabel="name" placeholder="" className="" />
                           </Grid>
                        </Grid>
                     </Box>
                     {/* added here Budget  */}
                     <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-bottom">
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                           <Typography level="title-sm" className='fs-1'>Budget and Scheduling</Typography>

                           <Grid container spacing={2}>
                              <Grid item xs={4}>
                                 <Typography level="title-sm" className='fs-2'>Campaign Start Date * </Typography>
                                 <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the Campaign Start date </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                 <Dropdown optionLabel="name" placeholder="" className="" />
                              </Grid>
                           </Grid>

                           <Grid container spacing={2}>
                              <Grid item xs={4}>
                                 <Typography level="title-sm" className='fs-2'>Campaign End Date * </Typography>
                                 <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the Campaign End date </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                 <Dropdown optionLabel="name" placeholder="" className="" />
                              </Grid>
                           </Grid>

                           <Grid container spacing={2}>
                              <Grid item xs={4}>
                                 <Typography level="title-sm" className='fs-2'>Campaign Time Zone* </Typography>
                                 <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the Campaign Time Zone</Typography>
                              </Grid>
                              <Grid item xs={8}>
                                 <Dropdown optionLabel="name" placeholder="" className="" />
                              </Grid>
                           </Grid>

                           <Grid container spacing={2}>
                              <Grid item xs={4}>
                                 <Typography level="title-sm" className='fs-2'>Campaign Start Time * </Typography>
                                 <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the Campaign Start Time </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                 <Dropdown optionLabel="name" placeholder="" className="" />
                              </Grid>
                           </Grid>

                           <Grid container spacing={2}>
                              <Grid item xs={4}>
                                 <Typography level="title-sm" className='fs-2'>Campaign End Time * </Typography>
                                 <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the Campaign End Time </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                 <Dropdown optionLabel="name" placeholder="" className="" />
                              </Grid>
                           </Grid>

                           <Grid container spacing={2}>
                              <Grid item xs={4}>
                                 <Typography level="title-sm" className='fs-2'>Campaign Total Budget * </Typography>
                                 <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the Campaign Total Budget</Typography>
                              </Grid>
                              <Grid item xs={8}>
                                 <Dropdown optionLabel="name" placeholder="" className="" />
                              </Grid>
                           </Grid>

                        </Box>
                     </Box>
                     <Box sx={{ minWidth: 0, display: 'flex', padding: '1rem', justifyContent: 'end' }} gap={2} className="form-footer">
                        <Button type="button" className="button-style-2" label="Cancel" size="small"></Button>
                        <Button type="button" className="button-style-1" label="Save" size="small"></Button>
                     </Box>
                  </Box>
               </Grid>
            </Grid>
         </Box>
      </div>
   );
};

export default NewDoohCampaign;

